import type { Normalizer } from '../format'

export class UppercaseNormalizer implements Normalizer {
  matches(input: string) {
    const hasUppercase = /^[A-Z]+$/.test(input)

    return hasUppercase
  }

  normalize(input: string) {
    return [input.toLowerCase()]
  }
}
